function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path fill="currentColor" d="M2 14V4H0v12h12v-2H2Zm14-2V0H4v12h12Z" />
    </svg>
  );
}

export default Icon;
